export const useIsButtonRegistryActive = (
  buttonActiveConditions,
  contactBody,
  pecAddress,
  installments,
  taxId,
  vatNumber,
  ibanError,
  pecError,
  installmentsError,
  taxIdError,
  vatError
) => {
  const isButtonActive = () => {
    if (contactBody?.iban.length > 0 && pecAddress?.length === 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !ibanError ? true : false;
    }
    if (contactBody?.iban.length === 0 && pecAddress?.length === 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions ? true : false;
    }
    if (pecAddress.length > 0 && contactBody?.iban.length > 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !ibanError && !pecError ? true : false;
    }
    if (pecAddress?.length > 0 && contactBody?.iban.length === 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !pecError ? true : false;
    }
    if (pecAddress?.length === 0 && contactBody?.iban.length === 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions ? true : false;
    }
    if (pecAddress?.length > 0 && contactBody?.iban.length === 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !pecError ? true : false;
    }
    if (pecAddress?.length > 0 && contactBody?.iban.length > 0 && installments?.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !pecError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !installmentsError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !installmentsError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !installmentsError && !pecError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !installmentsError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !installmentsError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !pecError && !ibanError && !installmentsError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !installmentsError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !pecError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !installmentsError && !pecError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !installmentsError && !ibanError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !pecError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length === 0) {
      return buttonActiveConditions && !taxIdError && !pecError && !ibanError && !installmentsError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !pecError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !ibanError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !taxIdError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError && !pecError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError && !taxIdError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !pecError && !ibanError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !pecError && !taxIdError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !ibanError && !taxIdError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length === 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError && !pecError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length === 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError && !taxIdError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length === 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !installmentsError && !taxIdError && !pecError ? true : false;
    }
    if (installments?.length === 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !vatError && !pecError && !taxIdError && !ibanError ? true : false;
    }
    if (installments?.length > 0 && pecAddress?.length > 0 && contactBody?.iban.length > 0 && taxId?.length > 0 && vatNumber.length > 0) {
      return buttonActiveConditions && !installmentsError && !vatError && !pecError && !taxIdError && !ibanError ? true : false;
    }
    return undefined;
  };

  return isButtonActive;
};
